import { useTranslation } from "react-i18next";
import { useImportVcfMutation, useLazyGetVcfImportStatusQuery, VCF_STATUS } from "@/services/api";
import { useAppDispatch, useAppSelector } from "@/services/store";
import { rootApi } from "@/services/api/api";
import { useAlert } from "@/shared/hooks";
import { vcfSliceActions, vcfSliceSelectors } from "../model";

export const useVcf = () => {
  const [importVcf, { isLoading: importIsLoading }] = useImportVcfMutation();
  const [getImportVcfStatus] = useLazyGetVcfImportStatusQuery();
  const { t } = useTranslation();
  const { callSuccess, callError } = useAlert();
  const dispatch = useAppDispatch();
  const vcfIsLoading = useAppSelector(vcfSliceSelectors.getIsLoading);

  const getImportVcfStatusHandler = () => {
    getImportVcfStatus()
      .unwrap()
      .then((res) => {
        if (res.userImportOperationStatus === VCF_STATUS.COMPLETED) {
          dispatch(vcfSliceActions.setIsLoading(false));
          dispatch(rootApi.util.invalidateTags(["person"]));
          callSuccess({ text: t("vcfUploadComplete") });
          return;
        }
        setTimeout(getImportVcfStatusHandler, 2000);
      });
  };

  const setVcfIsLoading = (isLoading: boolean) => {
    dispatch(vcfSliceActions.setIsLoading(isLoading));
  };

  const handleUpload = (file: File) => {
    const formData = new FormData();
    formData.append("file", file);
    importVcf(formData)
      .unwrap()
      .then(() => {
        setVcfIsLoading(true);
      })
      .catch(() => {
        setVcfIsLoading(false);
        callError({ text: t("vcfUploadError") });
      });
    return false;
  };

  return {
    methods: {
      handleUpload: handleUpload,
      setVcfIsLoading: setVcfIsLoading,
      getImportVcfStatusHandler: getImportVcfStatusHandler,
    },
    state: { vcfIsLoading: vcfIsLoading || importIsLoading },
  };
};
